export default __webpack_public_path__ + "static/media/1911.230440d3.png";